module.exports = __webpack_public_path__ + "static/media/Woodlands-South-Residential.4bbdc8b5.pdf";